import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { isDevtoolsEnabled } from './utils/isDevtoolsEnabled'

export interface StreakInfo {
  streakType: 'win' | 'loss'
  streakCount: number
  streakBoostPercent: number
}

interface StreakState {
  currentStreak: StreakInfo | null
}

export interface StreakActions {
  setStreak: (streak: StreakInfo | null) => void
  clearStreak: () => void
}

type StreakStore = StreakState & { actions: StreakActions }

export const useStreakStore = create<StreakStore>()(
  devtools(
    persist(
      (set) => ({
        currentStreak: null,
        actions: {
          setStreak: (streak: StreakInfo | null) => {
            set({ currentStreak: streak }, undefined, 'setStreak')
          },
          clearStreak: () => {
            set({ currentStreak: null }, undefined, 'clearStreak')
          }
        }
      }),
      {
        name: 'streak-storage',
        partialize: (state) => ({
          currentStreak: state.currentStreak
        })
      }
    ),
    { name: 'StreakStore', enabled: isDevtoolsEnabled() }
  )
)

export const useGetCurrentStreak = () => useStreakStore((state) => state.currentStreak)
export const useStreakActions = () => useStreakStore((state) => state.actions)
